<template>
  <div class="bg-white text-left py-6 px-12">
    <div class="border-b-1 border-hex-E4E4E4">
      <div class="flex space-x-3">
        <p class="text-lg">{{ $t("提现到银行卡") }}</p>
        <p
          class="
            bg-main
            w-8rem
            text-0.75rem
            flex-center
            text-white
            space-x-1
            cursor-pointer
          "
          @click="addCard"
        >
          <span class="iconfont icon-tianjia"></span>
          <span class="">{{ $t("去添加银行卡") }}</span>
        </p>
      </div>
      <div class="space-y-4 py-8">
        <el-radio-group v-model="radio" class="space-y-6" v-if="cardLength">
          <el-radio
            v-for="item in card_message"
            :key="item.id"
            :label="item.id"
            @change="changeCard(item)"
          >
            <span class="text-dark-100">{{ item.name }}</span>
            <span class="text-dark-100"
              >{{ $t("尾号") }}：{{
                item.cardno.slice(item.cardno.length - 4)
              }}</span
            >
          </el-radio>
        </el-radio-group>
        <img src="@/assets/image/暂无数据.png" v-else />
      </div>
    </div>
    <div class="pt-6 space-y-5">
      <p class="w-20rem whitespace-nowrap">
        {{ $t("提现") }}：
        <el-input
          :placeholder="$t('请输入提现金额')"
          class="w-15rem"
          v-model="withdrawalMoney"
          type="number"
        >
          <template slot="append">{{ $t("元") }}</template>
        </el-input>
      </p>
      <p class="text-0.75rem text-hex-909090 pb-5 pl-3.3rem">
        {{ $t("免服务费，预计次日到账") }}
        （{{ $t("最低提现额度100元") }}）
      </p>
      <el-button
        type="warning"
        class="w-9.56rem text-1rem ml-3.3rem"
        @click="next"
        :disabled="disabled"
      >
        {{ $t("下一步") }}
      </el-button>
    </div>
  </div>
</template>
<script>
import { ref, onMounted, computed, watchEffect } from "@vue/composition-api";

export default {
  setup(props, ctx) {
    const radio = ref(null);
    const addCard = () => {
      ctx.root.$router.push({
        name: "addCard",
      });
    };
    const card_message = ref();
    const cardLength = computed(() =>
      card_message?.value?.length ? card_message.value.length : 0
    );
    onMounted(async () => {
      card_message.value = (
        await ctx.root.$callapi("user/getBankCards", { page: 1, size: 100 })
      ).data.items;
    });
    const withdrawalMoney = ref(null);
    const disabled = ref(true);
    watchEffect(() => {
      disabled.value =
        withdrawalMoney.value >= 100 && radio.value && cardLength.value
          ? false
          : true;
    });
    //选中的银行卡信息
    const checkedCard = ref();
    //切换银行卡
    const changeCard = (item) => {
      checkedCard.value = item;
    };
    //下一步
    const next = () => {
      sessionStorage.setItem(
        "checkedCardMessage",
        JSON.stringify(checkedCard.value)
      );
      ctx.root.$router.push({
        name: "confirmWithdrawal",
        query: {
          withdrawalMoney: withdrawalMoney.value,
          bankCard_id: radio.value,
        },
      });
    };
    return {
      radio,
      addCard,
      withdrawalMoney,
      next,
      card_message,
      cardLength,
      disabled,
      changeCard,
    };
  },
};
</script>
<style scoped lang="scss">.el-radio-group ::v-deep .el-radio {
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
}
.el-radio ::v-deep span {
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
}
.el-radio ::v-deep span > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(0.75rem * var(--tw-space-x-reverse));
  margin-left: calc(0.75rem * calc(1 - var(--tw-space-x-reverse)));
}</style>
